import { createFileRoute, redirect } from '@tanstack/react-router';

import { getGovEvaluationsOptions } from '@/module/GovEvaluation/model/GovEvaluationQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/gov-evaluation/_layout/')({
  loader: async ({ context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(getGovEvaluationsOptions());
    if (data.length > 0) {
      throw redirect({ to: String(data[0].id) });
    }
  },
  component: () => <NoContentPlaceholder title="Selectați anul raportării din partea stângă" />,
});
